import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=a9a17db8&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=a9a17db8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a17db8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9a17db8')) {
      api.createRecord('a9a17db8', component.options)
    } else {
      api.reload('a9a17db8', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=a9a17db8&scoped=true&", function () {
      api.rerender('a9a17db8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Nod1hUW22Bya/JS/comp/PopupBox.vue"
export default component.exports